import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import { Provider } from 'react-redux';
import App from './App';
import { ENV_URL } from './constants';
import { store } from './redux/store';
import reportWebVitals from './reportWebVitals';
import { ToastContainer } from 'react-fox-toast';

async function enableMocking(): Promise<any> {
    if (process.env.NODE_ENV !== 'development' || true) {
        return;
    }

    const { worker } = await import('./__mocks__/browser');

    // `worker.start()` returns a Promise that resolves
    // once the Service Worker is up and ready to intercept requests.
    return worker.start();
}

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
enableMocking().then(() =>
    root.render(
        <React.StrictMode>
            <ToastContainer />
            <BrowserRouter basename={ENV_URL}>
                <Provider store={store}>
                    <App />
                </Provider>
            </BrowserRouter>
        </React.StrictMode>
    )
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
